import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { CytoFields, CytoSteps, TCytoPoint, TMemCytoData } from '../../data/CytoData';
import CF from './CytoNumberField';
import { useAppSelector } from './RunReduxHooks';
import { selectCyto } from './sliceCyto';
import { TabIcon, TabPanel } from './utilsTabView';

export interface ICytoEditProps {
    show: boolean
    closeCallback: () => void
}


export default function CytoEditDialog({ show, closeCallback }: ICytoEditProps) {
    const handleTabValueChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    }
    const cytoData=useAppSelector(selectCyto)
    const tabsCompletion = getTabsCompletion(cytoData)
    let firstNonComplete = tabsCompletion.findIndex(x => !x)
    firstNonComplete = firstNonComplete === -1 ? 0 : firstNonComplete
    const [tabValue, setTabValue] = useState(firstNonComplete)

    const onSave = () => {
        closeCallback()
    }

    return (
        <Dialog maxWidth='md' fullWidth open={show} >
            <DialogTitle>Enter cytokine results</DialogTitle>
            <DialogContent>
                <Tabs value={tabValue}  onChange={handleTabValueChange} style={{ height: '60px' }}>
                    {CytoSteps.map((x, i) =>
                        <Tab key={x} 
                            label={<Typography sx={{ fontSize: 14, fontWeight: 'bold' }}>{x} min</Typography>} 
                            icon={TabIcon(tabsCompletion[i])} iconPosition='end'  />
                    )}
                </Tabs>

                {CytoSteps.map((x, i) =>
                    <TabPanel key={x} value={tabValue} index={i}>
                            <CytoEdit timePointNumber={i}/>
                    </TabPanel>

                )}
            </DialogContent>
            <DialogActions>
                <DialogActions>
                    <Button variant='outlined' onClick={() => onSave()}>OK</Button>
                </DialogActions>
            </DialogActions>
        </Dialog>
    )
}

function getTabsCompletion(currentData: TMemCytoData) {
    return CytoSteps.map(x => allDataPresent(currentData[x]))
}

function allDataPresent(timePointData: TCytoPoint) {
    return CytoFields.every(field => timePointData[field] !== undefined && timePointData[field] !== null);
}

function CytoEdit({timePointNumber}:{ timePointNumber: number} ) {
    return(
        <Grid container columnSpacing={2} rowSpacing={2}>
            <Grid item xs={6} >
                <CF fullWidth field={'LAIL6'} step={CytoSteps[timePointNumber]} /> <br />
            </Grid>
            <Grid item xs={6}>
                <CF fullWidth field={'LAIL8'} step={CytoSteps[timePointNumber]} /> <br />
            </Grid>
            <Grid item xs={6}>
                <CF fullWidth field={'LAIL1B'} step={CytoSteps[timePointNumber]} /> <br />
            </Grid>
            <Grid item xs={6}>
                <CF fullWidth field={'LAIL10'} step={CytoSteps[timePointNumber]} /> <br />
            </Grid>
        </Grid>
    )
}
